import { ComponentApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes, reNameStatus } from './constants';
import logger from 'helpers/logger';
import { getApiActionCreator } from 'helpers/actionHelper';
import { getAvailableAssets, loadPowertrainsV2 } from '../../../../GeneralFilter/GeneralFilterModal/actions';
import { sortBy } from 'lodash';
import { setSelectedAsset } from '../../../AssetPowertrainSelector/actions';
import { actionTypes as powertrainAssetOviewActionTypesV2 } from '../../../../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/constants';

const renameAssetAction = getApiActionCreator(actionTypes.UPDATE_ASSET_RENAME);

export const updateAssetList = () => {
    return (dispatch, getState) => {
        const generalFilter = getState()?.generalFilter;
        const selectedFilters = generalFilter?.selectedFilters;
        const isCIAMSyncFlag = generalFilter?.refeshCIAMSync;
        const organizations = selectedFilters?.organizations;
        const isAdmin = getState().overview?.user?.data?.isAdminFromCIAM;
        const sites = getState().generalFilter?.sites?.data;
        const countries = selectedFilters?.countries;
        const selectedOrganizations = sortBy(organizations, (o) => (o.organizationName || '').toLowerCase());
        let refreshFlag = true;
        if (isAdmin && !isCIAMSyncFlag) {
            refreshFlag = false;
        }
        dispatch(getAvailableAssets(selectedOrganizations, refreshFlag));
        loadPowertrainsV2(sites, selectedOrganizations, refreshFlag, dispatch, countries);
    };
};

export const updateAsset = (asset) => {
    return (dispatch) => {
        dispatch(renameAssetAction(apiCallStatus.LOADING));

        ComponentApi.updateAsset(asset)
            .then((data) => {
                //TODO: It seems this first 2 dispatch methods are unused, need to verify and remove.
                dispatch(renameAssetAction(apiCallStatus.SUCCESS));
                dispatch({ type: actionTypes.UPDATE_ASSET_RENAME_SUCCESS, data: { ...asset, eTag: data.eTag } });
                dispatch(setSelectedAsset({ ...asset, name: data.assetName, eTag: data.eTag }));
                logger.debug('Asset was successfully updated');
                dispatch({
                    type: powertrainAssetOviewActionTypesV2.UPDATE_ASSET_NAME,
                    data: {
                        id: asset.id,
                        name: data.assetName
                    }
                });
                dispatch(updateAssetList());
                dispatch({ type: actionTypes.CLOSE_DIALOGUE, data: { reName: reNameStatus.reNameAsset } });
            }, (err) => {
                dispatch(renameAssetAction(apiCallStatus.ERROR, null, err));
            });
    };
};
